import { useWatch, FieldPath } from 'react-hook-form';
import { AlgorithmJoinsFormDataType } from './joins/schema/types';

export const useAlgorithmFormValues = <
  N extends readonly FieldPath<AlgorithmJoinsFormDataType>[],
>(
  name: N,
) => useWatch<AlgorithmJoinsFormDataType, N>({ name });
